import React from 'react';
import NoSsr from '@material-ui/core/NoSsr';
import StarRating from '../../shared/StarRating';

export default function MapStarRating({ rating }) {
  const [ratingState, setRatingState] = React.useState(rating);
  const onChange = (e, newRating) => setRatingState(newRating);
  return (
    <NoSsr>
      <StarRating config={ratingState} handler={onChange} />
    </NoSsr>
  );
}
